'use client';

import { useState, useCallback, useEffect } from 'react';

var useElementResize = function (ref) {
    var _a = useState({
        width: 0,
        height: 0
    }), size = _a[0], setSize = _a[1];
    var onResize = useCallback(function () {
        setSize({
            width: (ref === null || ref === void 0 ? void 0 : ref.offsetWidth) || 0,
            height: (ref === null || ref === void 0 ? void 0 : ref.offsetHeight) || 0
        });
    }, [ref === null || ref === void 0 ? void 0 : ref.offsetHeight, ref === null || ref === void 0 ? void 0 : ref.offsetWidth]);
    useEffect(function () {
        if (typeof window === 'undefined')
            return;
        onResize();
        window.addEventListener('resize', onResize);
        return function () {
            window.removeEventListener('resize', onResize);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return [size];
};

export { useElementResize as default };
//# sourceMappingURL=index.js.map
